<template>
  <b-sidebar
        title="Цуцлах"
        backdrop
        right
        shadow
        v-model="showSidebar"
        @change="visibleChanged"
        width="50vw"
        scrollable
      >
        <div class="bg-white d-flex bd-t" v-if="showSidebar">
          <div class="wd-100p">
            <div class="overflow-auto d-flex flex-column align-items-center justify-content-center" style="height: calc(100vh - 110px)">
            <div class="wd-300 mg-b-20">
              <div>Үндэслэл бичнэ үү</div>
                <textarea v-model="tsk.undeslel" class="form-control" rows="4" placeholder="Үндэслэл"></textarea>
            </div>
              <simple-uploader
                :propObjectId="6"
                :propObjectTypeId="6"
                @on-success="fileUploadedSetting"
                class="wd-300"
              >
                <div slot="trigger" class="wd-100p">
                  <a v-if="tsk.fourthAttachmentId == 0 || tsk.fourthAttachmentId == null"
                    class="dropdown-item" >Компьютероос хуулах
                  </a>
                  <div v-else class="btn-group wd-100p">
                    <!-- <div class="btn btn-outline-success" @click.stop="dtl.modal = false; $emit('on-attach', tsk.fourthAttachmentId)">
                      <feather type="eye"></feather>Файл харах
                    </div> -->
                    <div class="btn btn-danger" @click.prevent.stop="tsk.fourthAttachmentId = null">
                      <feather type="x"></feather>Салгах
                    </div>
                  </div>
                </div>
              </simple-uploader>
            </div>   
            <div class="ht-55 bd-t d-flex align-items-center pd-x-10 bg-light">
              <a @click="saveCancel()" class="btn btn-success mg-l-auto">Хадгалах</a>
            </div>         
          </div>
        </div>

    <file-dialog
      :show="fileDialog.show"
      :id="fileDialog.id"
      @on-hide="fileDialog.show = false"
    />
      </b-sidebar>
</template>

<script>

import { request } from "@/api/all";
var _ = require("lodash");
import { mapActions } from "vuex";

import "element-ui/lib/theme-chalk/index.css";
import { Notification, Select, Option, Input, InputNumber, MessageBox } from "element-ui";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import { getDetailFields } from "@/api/taskCore";
import loader from "@/components/box/loader/loader.vue";


export default {
  components:{
    loader,
    Select, Option, Input, InputNumber, MessageBox, 
    simpleUploader: () => ({
      component: import("@/components/modules/media/simpleUploader.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    fileDialog: () => ({
      component: import("@/components/modules/media/preview.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  name: "projectUsers",
  data: () => ({
    tsk:{
      undeslel: null,
      fourthAttachmentId: null,
    },
    markLast:{
      thirdAttachmentId: null
    },
    fileDialog: {
        id: null,
        show: false,
      },
    pointsDta: {
        points: [],
        projectTaskId: null,
        userId: null,
      },
    markObj: {
        fields: [],
        task: {
          b: [],
        },
        id: null,
        modal: false,
        fetched: false,
      },
    showSidebar: false,
    users: [],
    usersCount: null,
    fetched: false,
    //boxes:[],
    allDta: {
      projectTaskId: 0,
      boxSettings: [],
      keyFilter: false,
      interestsFilter: false,
    },
    loading: false,
    pnts:{
      modal: false,
      types: []
    }
  }),
  props: {
    obj: {
      type: Object,
      default: () => {}
    },
    show: {
      type: Boolean,
      default: () => false
    },
  },
  watch: {
    show: function(newVal) {
      if (newVal) {
        this.canSettings();
      }else{
        this.showSidebar= false;
      }
    },
    // obj: function(newVal) {
    //   // console.log('newVal', newVal);
    //   this.init();
    //   // if (this.showSidebar && newVal.days!=undefined && (newVal.days==1 || newVal.days==2)) {
    //   //   if(newVal.days==1){
    //   //     this.fetchAssignedMembers();
    //   //   }else{
    //   //     this.init();
    //   //   }
    //   // }
    // }
  },
  mounted() {
    
  },
  methods: {
    saveCancel(){
      request({
        api: { method: "POST", url: "ProjectEdu/SaveFourthAttachmentIdAndIsCompletedFalse" },
        data: {
          id: this.obj.id, 
          undeslel: this.tsk.undeslel,
          fourthAttachmentId: this.tsk.fourthAttachmentId
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          Notification.success({
            message: 'Амжилттай',
            duration: 5000,
          });
          this.visibleChanged(false);
          //console.log("res", res);
        }
      });
    },
    fileUploadedSetting(e) {
      this.tsk.fourthAttachmentId = e.uploadedAttachmentId;
    },
    showDetail() {},
    loadBoxData() {},
    canSettings() {
      this.init();
    },
    init() {
      this.showSidebar = true;
      this.tsk= this.obj;
    },
    visibleChanged(e) {
      //console.log('visibleChanged', e);
      if (!e) {
        //this.allDta.boxSettings= [];
        //this.showSidebar = false;
        this.$emit("on-assign-close");
      }
    },
  }
};
</script>
<style>
.test-modal-dialog {
  max-width: 100%;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100vh;
  display: flex;
  position: fixed;
  z-index: 100000;
}
</style>